<!--
 * @Author: xiaokun
 * @Date: 2020-06-11 15:11:03
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-22 16:48:15
 * @Description: 设置关键词/商品标签 弹窗 关键词/商品标签每一项
-->
<template>
  <div
    class="common-setting-drawer-list-item cursor"
  >
    <div
      v-if="!isShowEdit"
      class="show-item"
    >
      <div class="item-name">
        {{ itemData.name }}
      </div>
      <div class="item-options">
        <!-- 编辑 -->
        <mk-tooltip
          content="编辑"
          placement="top"
        >
          <ds-iconfont
            icon-class="icon-mk-bianji"
            @click="handelOnEditClick"
          />
        </mk-tooltip>

        <!-- 删除 -->
        <mk-popover
          :key="`popover-${itemData._id}`"
          v-model="isShowDelete"
          placement="top"
          trigger="click"
          popper-class="question-bank-delete-confirm"
        >
          <div>
            <div class="mention-text">
              <mk-iconfont icon-class="guanbihuojingshihuocuowu" />删除后已有该内容的词条也会清空，是否确认?
            </div>
            <div class="button">
              <mk-button-biz
                width="50px"
                height="24px"
                @click="confirmDelete"
              >
                确定
              </mk-button-biz>
              <mk-button-biz
                width="50px"
                height="24px"
                type="primary"
                @click="closeConfirm"
              >
                取消
              </mk-button-biz>
            </div>
          </div>
          <!-- 删除内容 -->
          <span slot="reference">
            <mk-tooltip
              content="删除"
              placement="top"
            >
              <ds-iconfont
                icon-class="icon-mk-shanchutp"
              />
            </mk-tooltip>
          </span>
        </mk-popover>
      </div>
    </div>
    <div
      v-else
      class="edit-item"
    >
      <mk-input
        v-model="editData"
        width="320"
        :maxlength="'10'"
        show-word-limit
      />
      <div class="add-new-input-options">
        <span
          class="add-new-save cursor"
          @click="handleOnSaveEditClick"
        >保存</span>
        <span
          class="add-new-cancel cursor"
          @click="handleOnCancelEditClick"
        >取消</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonSettingDrawerListItem',
  components: {
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {
          name: '',
          _id: ''
        }
      }
    },
    index: {
      type: Number,
      default: null
    },
    listActive: {
      type: Number,
      default: null
    },
    // 是否为关键词
    isKeyord: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowOption: false,
      // 是否展示正在编辑的输入框
      isShowEdit: false,
      isShowDelete: false,
      editData: this.itemData.name
    }
  },
  watch: {
    listActive (cur, old) {
      if (cur !== old && cur !== this.index && this.isShowDelete) {
        this.closeConfirm()
      }
    }
  },
  methods: {

    // 打开编辑弹窗
    handelOnEditClick () {
      let isShowEditState = this.util.storage.getItem('speech-storehouse-common-setting-drawer')
      // 打开就赋值
      this.editData = this.itemData.name
      // this.isShowEdit = true
      if (this.isShowEdit) {
        this.closeEdit()
      } else {
        if (isShowEditState) {
          this.$message.error('请保存正在编辑内容后进行其他操作')
          return false
        }
        this.util.storage.setItem('speech-storehouse-common-setting-drawer', true)
        this.util.storage.setItem('speech-storehouse-common-setting-drawer-id', this.itemData._id)
        this.isShowEdit = true
      }
    },
    closeEdit () {
      this.isShowEdit = false
      this.util.storage.setItem('speech-storehouse-common-setting-drawer', false)
    },
    // 保存编辑
    handleOnSaveEditClick () {
      if (this.editData === '') {
        let content = this.isKeyord ? '请输入关键词' : '请输入商品标签'
        this.$message.error(content)
      } else if (this.editData !== this.itemData.name) {
        // 设置数据新字段
        this.itemData.newName = this.editData
        // 提交父级执行事件
        this.$emit('on-save-edit', this.itemData)
        // 关闭编辑输入框
        setTimeout(() => {
          this.handleOnCancelEditClick()
        }, 200)
      } else {
        this.handleOnCancelEditClick()
      }
    },

    // 取消编辑
    handleOnCancelEditClick () {
      this.closeEdit()
      this.editData = this.itemData.name
    },
    closeConfirm () {
      this.isShowDelete = false
    },
    // 确认删除
    confirmDelete () {
      this.closeConfirm()
      // 提交父级执行删除事件事件
      this.$emit('on-confim-delete', this.itemData)
    },
    // 父级直接关闭了弹窗
    closeParentDrawer () {
      this.handleOnCancelEditClick()
    }
  }
}
</script>
<style lang='scss' scoped>
.common-setting-drawer-list-item {
  padding: 0 10px;

  .show-item {
    line-height: 36px;
    color: #262626;
    font-size: 13px;
    display: flex;
    justify-content: space-between;

    .item-options {
      color: #262626;
      display: none;

      /deep/ .ds-iconfont {
        margin-left: 16px;

        &:hover {
          color: #009cff;
        }
      }
    }
  }

  &.active {
    background-color: #ebf7ff;

    .item-options {
      display: block;
      height: 36px;
    }
  }

  .edit-item {
    display: flex;
    align-items: center;
    line-height: 36px;

    /deep/ .el-input__inner {
      padding-left: 12px;
    }

    .add-new-input-options {
      margin-left: 16px;
      font-size: 14px;

      .add-new-save {
        margin-right: 8px;
        color: #009cff;
      }

      .add-new-cancel {
        color: #888;
      }
    }
  }
}
</style>
